import React from 'react';

// Components
import ImagePreview from './partials/ImagePreview';
import { UploadImageModal } from '../modals';
import { DestructiveModal } from '@capintel/component-lib/destructive-modal';

// Utils
import { formatMessage } from '@/utils/i18n';
import { withErrorBoundary } from '../errors';
import Nullable from '@/types/nullable';

type Props = {
  imgUrl?: Nullable<string>;
  isUploadCoBrandingLogo?: boolean;
  i18nPath: string;
  onDelete: () => void;
};

enum Modals {
  UPLOAD = 'uploadModal',
  DELETE = 'deleteModal',
}

const ImageUploader = ({ imgUrl, isUploadCoBrandingLogo, i18nPath, onDelete }: Props) => {
  const [isVisible, setIsVisible] = React.useState({
    [Modals.UPLOAD]: false,
    [Modals.DELETE]: false,
  });
  const toggleModal = (modal: Modals, visibilityState: boolean) => () => setIsVisible({ ...isVisible, [modal]: visibilityState });
  const onConfirmDelete = () => {
    onDelete();
    toggleModal(Modals.DELETE, false)();
  };
  return (
    <>
      <ImagePreview
        imgUrl={imgUrl}
        showDeleteImageModal={toggleModal(Modals.DELETE, true)}
        showUploadImageModal={toggleModal(Modals.UPLOAD, true)}
        i18nPath={i18nPath}
      />
      <UploadImageModal
        targetImgUrl={imgUrl}
        i18nPath={`${i18nPath}.UploadModal`}
        show={isVisible.uploadModal}
        onCancel={toggleModal(Modals.UPLOAD, false)}
        isUploadCoBrandingLogo={isUploadCoBrandingLogo}
      />
      <DestructiveModal
        open={isVisible.deleteModal}
        onOpenChange={open => !open && toggleModal(Modals.DELETE, false)()}
        title={formatMessage(`${i18nPath}.DeleteModal.Title`)}
        content={formatMessage(`${i18nPath}.DeleteModal.Body`)}
        confirmButtonText={formatMessage(`${i18nPath}.DeleteModal.ConfirmButton`)}
        cancelButtonText={formatMessage('Common.Cancel')}
        onCancel={toggleModal(Modals.DELETE, false)}
        onConfirm={onConfirmDelete}
      />
    </>
  );
};

export default withErrorBoundary(ImageUploader);
